module.exports = __webpack_public_path__ + "img/rejectedRed.759fb0bd.png";